import { getIconByName } from '../components/Sidebar'
import { availableModuleIcons, resolveModuleHeroIcon } from './moduleHeroIcons'
import { availableLucideModuleIcons, resolveModuleLucideIcon } from './moduleLucideIcons'
import { resolveModuleIcon } from './moduleIconResolver'
import { CUSTOM_MODULE_ICON_NAMES } from './moduleIconCategories'

/** Ícone do módulo conforme campo `icon` do banco (mesmo mapa da Sidebar). */
export const getModuleIcon = (iconName?: string) => getIconByName(iconName)

export { CUSTOM_MODULE_ICON_NAMES, resolveModuleIcon }

/**
 * Lista completa para o modal "Selecione um ícone":
 * Heroicons + Lucide + ícones customizados da Sidebar.
 */
export const getAvailableModuleIcons = () => {
  const byName = new Map(
    availableModuleIcons.map((icon) => [icon.name, icon] as const)
  )

  for (const icon of availableLucideModuleIcons) {
    byName.set(icon.name, icon)
  }

  for (const name of CUSTOM_MODULE_ICON_NAMES) {
    byName.set(name, { name, component: getIconByName(name) })
  }

  return Array.from(byName.values()).sort((a, b) => a.name.localeCompare(b.name))
}

export { availableModuleIcons, resolveModuleHeroIcon, availableLucideModuleIcons, resolveModuleLucideIcon }
